import $ from 'jquery';
import asimov from '@99designs/asimov-core';
import Tooltip from './lib/tooltip';

var pluginName = 'tooltip',
    defaults = {
        show: 'mouseenter',      // event
        location: 'down-center', // direction-alignment (e.g. up-center) || up-fluid || down-fluid
        spacing: 10,             // in pixels (space from target)
        variations: ''           // style variations
    };

function build(options, elem) {
    var obj = new Tooltip().init(options, elem);

    return {
        show: function () {
            obj.show(obj.$elem, obj.$tooltip, options);
            return this;
        },

        hide: function () {
            obj.hide(obj.$tooltip);
            return this;
        }
    };
}

// Plugin definition

$.fn[pluginName] = function(options) {
    return this.each(function() {
        if (!$.data(this, pluginName)) {
            var opts = asimov.mergeElementData(
                $(this),
                pluginName,
                $.extend(true, {}, defaults, options)
            );

            $.data(this, pluginName, build(opts, this));
        }
    });
};



// WEBPACK FOOTER //
// ./~/@99designs/asimov-tooltip/index.js